import React from 'react';
import { FaCalendarAlt } from 'react-icons/fa';

const DecadeFilter = ({ decadeFilter, setDecadeFilter }) => {
  const handleDecadeChange = (event) => {
    setDecadeFilter(event.target.value);
  };

  return (
    <div className="filter-control-item">
      <label htmlFor="decade-filter" className="filter-control-label">
        <FaCalendarAlt className="icon-purple" /> Era / Decade
      </label>
      <select
        id="decade-filter"
        className="filter-select-custom"
        value={decadeFilter}
        onChange={handleDecadeChange}
        aria-label="Filter by decade"
      >
        <option value="all">All Eras</option>
        <option value="2020">2020s (Modern Hits)</option>
        <option value="2010">2010s (Recent Classics)</option>
        <option value="2000">2000s (Millennium)</option>
        <option value="1990">1990s (90s Golden Era)</option>
        <option value="1980">1980s (80s Classics)</option>
        <option value="1970">1970s (Vintage)</option>
      </select>
    </div>
  );
};

export default DecadeFilter;